module.exports = __webpack_public_path__ + "static/media/family_Ink_header.be743d0d.png";